var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "ranges-search" } },
    [
      _c(
        "b-container",
        { staticClass: "pt-2 bg-light mb-3", attrs: { fluid: "" } },
        [
          _c(
            "b-container",
            [
              _c("search-form", {
                model: {
                  value: _vm.filters,
                  callback: function ($$v) {
                    _vm.filters = $$v
                  },
                  expression: "filters",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        [
          _vm.ranges.length > 0 || _vm.loading
            ? _c(
                "b-row",
                { staticClass: "grid" },
                _vm._l(_vm.ranges, function (range, index) {
                  return _c("range-result", {
                    key: index,
                    attrs: { range: range },
                  })
                }),
                1
              )
            : _c("p", { staticClass: "text-center text-muted lead" }, [
                _vm._v("No Ranges Found"),
              ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-center mb-3" },
        [
          _vm.loading
            ? _c("b-spinner")
            : !_vm.endOfResults
            ? _c(
                "b-button",
                {
                  attrs: { variant: "brand", size: "lg" },
                  on: { click: _vm.loadRanges },
                },
                [_vm._v("Load More Results")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }